/* eslint-disable @typescript-eslint/naming-convention */
export interface ProjectModel {
	project_name: string;
	uofm_code: string;
	project_number: string;
}
